;(function () {
  'use strict'

  angular.module('iqxCore').service('serviceWorkerSvc', serviceWorkerSvc)

  function serviceWorkerSvc(ApplicationSvc, newVersionSvc, toastSvc, ApiSvc, $location, $cookies, $timeout, $window) {
    var svc = this
    svc.installOrUpdate = installOrUpdate
    svc.registerPush = registerPush
    svc.getRegToken = getRegToken
    svc.registerIOSPush = registerIOSPush
    svc.turnOff = turnOff
    svc.getDevices = getDevices
    svc.removeToken = removeToken
    svc.messaging = {}
    svc.isIOS = false

    ///////////

    function swClearWorker() {
      var i = 0
      navigator.serviceWorker
        .getRegistrations()
        .then(function (registrations) {
          for (let registration of registrations) {
            i++
            registration.unregister()
          }
        })
        .then(function () {
          if (i > 0) {
            window.caches.keys().then(function (cacheNames) {
              cacheNames.forEach(function (cacheName) {
                caches.delete(cacheName)
              })
            })
            indexedDB.deleteDatabase('workbox-expiration')
            newVersionSvc.prompt()
          }
        })
    }

    function clearSWCache() {
      /* 
                Check for and clear the service worker cache as we are no longer using runtime caching
                provided by the service worker, instead we are relying on browser caching.
            */
      let i = 0
      window.caches.keys().then(function (cacheNames) {
        cacheNames.forEach(function (cacheName) {
          i++
          caches.delete(cacheName)
        })
      })
      if (i > 0) {
        indexedDB.deleteDatabase('workbox-expiration')
        newVersionSvc.prompt()
      }
    }

    function installOrUpdate() {
      /* Check if Service Workers are supported by the browser ... */
      if (!('serviceWorker' in navigator)) {
        return
      }

      if (ApplicationSvc.params.USESVCWORKER === true) {
        clearSWCache()
        window.isUpdateAvailable = new Promise(function (resolve, reject) {
          navigator.serviceWorker
            .register('sw.js')
            .then(function (registration) {
              registration.onupdatefound = function () {
                var installingWorker = registration.installing
                installingWorker.onstatechange = function () {
                  switch (installingWorker.state) {
                    case 'installed':
                      if (navigator.serviceWorker.controller) {
                        newVersionSvc.prompt()
                        resolve(true)
                      } else {
                        resolve(false)
                      }
                      break

                    case 'redundant':
                      resolve(true)
                      break
                  }
                }
              }
            })
            .then(function () {
              var firebaseConfig = {
                apiKey: ApplicationSvc.params.FB_APIKEY,
                authDomain: ApplicationSvc.params.FB_AUTHDOMAIN,
                databaseURL: '',
                projectId: ApplicationSvc.params.FB_PROJECTID,
                storageBucket: '',
                messagingSenderId: `"${ApplicationSvc.params.FB_MSGSENDERID}"`,
                appId: ApplicationSvc.params.FB_APPID
              }
              $timeout(function () {
                firebase.initializeApp(firebaseConfig)
                svc.messaging = firebase.messaging()

                // Event listener for when a new message is received while window is focused.
                navigator.serviceWorker.addEventListener('message', function (event) {
                  if (event.data && event.data.notification && event.data.messageType === 'push-received') {
                    showNotification(event.data.notification)
                  }
                })
              }, 1000)
            })
            .catch(function (err) {
              toastSvc.error('Application Error', err)
            })
        })

        window.addEventListener('load', function () {
          function updateOnlineStatus(event) {
            if (!navigator.onLine) {
              toastSvc.error('Offline', 'You are no longer connected to the internet.', 'offlineToast')
            } else {
              toastSvc.clear('offlineToast')
            }
          }
          window.addEventListener('online', updateOnlineStatus)
          window.addEventListener('offline', updateOnlineStatus)
        })
      } else {
        /* 
            Check for Service Worker installation and REMOVE 
            it as well as clearing the cache storage. (as its disabled) 
        */
        swClearWorker()
      }
    }

    async function turnOff() {
      let currentToken = window.localStorage.getItem('fcmtoken')
      if (currentToken) {
        return navigator.serviceWorker
          .getRegistrations()
          .then(function (registrations) {
            angular.forEach(registrations, function (registration) {
              registration.unregister()
            })
            $cookies.remove('pushPermissions')
            window.localStorage.removeItem('tokenSavedOnServer')
            window.localStorage.removeItem('fcmtoken')
          })
          .then(function () {
            return removeToken(currentToken)
          })
      }
    }

    async function registerPush(getToken = false) {
      var iOS = !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform)
      if (navigator.platform === 'MacIntel' || navigator.platform === 'iPad' || navigator.platform === 'iPhone') {
        // iOS App
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['push-permission-request']) {
          window.iOSPushCapability = true
        }
        window.addEventListener('push-permission-request', function (message) {
          console.info(message) // intentionally left in
        })
        window.addEventListener('FCM-token-handle', async function (message) {
          console.info(message) // intentionally left in
          /* 
                        FCM token is returned as "Optional(\"<TOKEN>\")"
                        So just tidying it up with some regex so its useable.
                    */
          var fcmToken = message.detail.match(/\"(.*?)\"/)[0].replace(/\"/g, '')
          $cookies.put('pushPermissions', '1')
          return saveToken(fcmToken)
            .then(function () {
              return setTokenSentToServer(true)
            })
            .then(function () {
              svc.isIOS = true
              toastSvc.success('Notifications Enabled', 'You will now receive push notifications')
            })
        })

        try {
          window.webkit.messageHandlers['push-permission-request'].postMessage('push-permission-request')
          window.webkit.messageHandlers['FCM-token-handle'].postMessage('FCM-token-handle')
        } catch (error) {
          console.error(error)
        }
      }
      if (iOS === false) {
        return navigator.serviceWorker
          .register('sw.js')
          .then(function (registration) {
            svc.messaging.useServiceWorker(registration)
          })
          .then(function () {
            return svc.messaging.requestPermission()
          })
          .then(function (res) {
            $cookies.put('pushPermissions', '1')
            if (!isTokenSentToServer()) {
              if (getToken === true) {
                getRegToken()
              }
            }
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    }

    function registerIOSPush(token) {
      $cookies.put('pushPermissions', '1')
      svc.isIOS = true
      return saveToken(token)
    }

    function getRegToken() {
      return svc.messaging
        .getToken()
        .then(function (currentToken) {
          if (currentToken) {
            saveToken(currentToken)
            setTokenSentToServer(true)
          } else {
            setTokenSentToServer(false)
          }
        })
        .catch(function (err) {
          console.error('An error occurred while retrieving token. ', err)
          setTokenSentToServer(false)
        })
    }

    function setTokenSentToServer(sent) {
      window.localStorage.setItem('tokenSavedOnServer', sent ? 1 : 0)
    }

    function isTokenSentToServer() {
      return window.localStorage.getItem('tokenSavedOnServer') == 1
    }

    function hashCode(s) {
      var h
      for (var i = 0; i < s.length; i++) {
        h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
      }

      return 'PUSHDEVICE' + Math.abs(h) // positive only value
    }

    function getOS() {
      // 0 = Unknown / 1 = Windows / 2 = macOS / 3 = Linux / 4 = Android / 5 = iOS
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = 0

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 2
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 5
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 1
      } else if (/Android/.test(userAgent)) {
        os = 4
      } else if (!os && /Linux/.test(platform)) {
        os = 3
      }
      return os
    }

    function OSName(OS) {
      switch (OS) {
        case 0:
          return 'Unknown Device'
        case 1:
          return 'Windows Device'
        case 2:
          return 'Apple Mac Device'
        case 3:
          return 'Linux Device'
        case 4:
          return 'Android Phone/Tablet'
        case 5:
          return 'Apple Device'
      }
    }

    function getDevices() {
      let fetchScope = {}
      return ApiSvc.fetch(fetchScope, {
        fetchAPI: 'callresult/_NetPushNotificationsDevices',
        fetchTarget: 'devices',
        dateFields: ['WhenCreated'],
        multiRow: true
      }).then(function () {
        return fetchScope.devices
      })
    }

    function removeToken(currentToken) {
      return ApiSvc.exec(
        svc,
        'call/_NetPushNotificationsDeviceRemove',
        {
          pDeviceID: currentToken
        },
        false
      ).catch(function (e) {
        console.error('Error Removing Token', e)
      })
    }

    function saveToken(currentToken) {
      let tokenHash = hashCode(currentToken)
      window.localStorage.setItem('fcmtoken', tokenHash)
      return ApiSvc.exec(
        svc,
        'call/_NetPushNotificationsDeviceAdd',
        {
          pDeviceID: tokenHash,
          pDeviceToken: currentToken,
          pDeviceName: `${ApplicationSvc.currentUser.UserName}'s ${OSName(getOS())}`,
          pDeviceType: getOS()
        },
        false
      ).catch(function (e) {
        console.error('Error Saving Token', e)
      })
    }

    function showNotification(notification) {
      svc.notification = iziToast.show({
        animateInside: true,
        title: notification.title,
        message: notification.body,
        image: notification.image,
        icon: notification.image ? '' : 'fas fa-info fa-fw animated slow',
        iconColor: '#fff',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        transitionInMobile: 'fadeIn',
        transitionOutMobile: 'fadeOut',
        backgroundColor: '#0066a9',
        titleColor: '#fff',
        titleSize: 18,
        messageColor: '#fff',
        messageSize: 16,
        timeout: 1000 * 60 * 5,
        displayMode: 0,
        buttons: notification.click_action
          ? [
              [
                '<button class="btn">Open</button>',
                function (instance, toast) {
                  $window.location.pathname = notification.click_action
                }
              ]
            ]
          : []
      })
    }
  }
})()
